import {
  Alert,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  Stack,
} from "@mui/material";
import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import useRequests from "../hooks/http";
import { Status } from "../enums/status";
import StatusDisplay from "../components/feedback/Status";

export default function Reset() {
  const { post } = useRequests();
  const [status, setStatus] = useState(Status.PENDING);
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setStatus(Status.LOADING);
    const { data, status: httpStatus } = await post("/password/reset-request", {
      email,
    });
    if (httpStatus && httpStatus >= 200 && httpStatus < 300) {
      setMessage(
        data?.message ||
          "If an account exists for that email, a reset link has been sent.",
      );
      setStatus(Status.SUCCESS);
    } else {
      setMessage("Something went wrong. Please try again.");
      setStatus(Status.ERROR);
    }
  };

  return (
    <Stack
      component={"form"}
      sx={{ flexGrow: 1 }}
      spacing={2}
      onSubmit={handleSubmit}
    >
      <Alert severity="info">
        Enter your email address to receive a password reset link.
      </Alert>

      <StatusDisplay status={status} message={message} />

      <FormControl fullWidth={true}>
        <InputLabel htmlFor="reset-email">Email address</InputLabel>
        <OutlinedInput
          id="reset-email"
          placeholder="Email address"
          label="Email address"
          type="email"
          name="email"
          autoComplete="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </FormControl>
      <Button
        variant="contained"
        type="submit"
        disabled={status === Status.LOADING || status === Status.SUCCESS}
      >
        Send reset link
      </Button>
      <Button component={Link} to="/">
        Back to login
      </Button>
    </Stack>
  );
}
